import { render, staticRenderFns } from "./ConfigurazioniMagazzinoFornitoriModalEditComponent.vue?vue&type=template&id=99ddc37c"
import script from "./ConfigurazioniMagazzinoFornitoriModalEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoFornitoriModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports